module.exports = {
  provides: 'device',
  shouldTrack: true,
  isSticky: true,

  getter: [
    'sources/device',
    function(DeviceSource) {
      return DeviceSource.getDevice();
    }
  ]
};
